module.exports = __webpack_public_path__ + "static/media/tram.38533ac6.svg";